import React from 'react'
import { connect } from 'react-redux'
import { TicketNarrativeBar } from 'view/shared/ticket'
import { NegotiationDetail, NegotiationStatus, NegotiationActions, AuditDetail } from 'api'
import { Translation, Locale } from 'locale'
import { isLastLook, canRevert, isAuditDetail, isNegotiationHistory } from '../shared/utils'
import { LinkButton } from 'view/components/buttons'

export interface RFQTicketNarrativeBarProps {
  negotiationDetail: NegotiationDetail | AuditDetail
  onInitiatorRevert: (negotiationId: string, ownOrder: boolean) => unknown
  onResponderRevert: (negotiationId: string, ownOrder: boolean) => unknown
}

const mapDispatchToProps = {
  onInitiatorRevert: NegotiationActions.initiatorRevert,
  onResponderRevert: NegotiationActions.responderRevert
}

export class RFQTicketNarrativeBarComponent extends React.Component<RFQTicketNarrativeBarProps> {
  render() {
    const { negotiationDetail } = this.props
    const narrative = this.getNarrative()

    if (!isAuditDetail(negotiationDetail) && canRevert(negotiationDetail)) {
      return (
        <TicketNarrativeBar revertible={true}>
          {Locale.translate(Translation.SC_TICKET_MODIFIED_NARRATIVE)}
          <LinkButton onClick={this.handleRevert}>{Locale.translate(Translation.TC_ACTION_UNDO)}</LinkButton>
        </TicketNarrativeBar>
      )
    } else if (narrative) {
      return <TicketNarrativeBar>{narrative}</TicketNarrativeBar>
    } else {
      return null
    }
  }

  private getNarrative = () => {
    const { negotiation, ownOrder } = this.props.negotiationDetail
    const status = negotiation.status

    if (!isNegotiationHistory(negotiation) && isLastLook(negotiation)) {
      return Locale.translate(Translation.SC_TICKET_LAST_LOOK_NARRATIVE)
    }

    switch (status) {
      case NegotiationStatus.WITHDRAWN:
        const isWithdrawnByInitiator = negotiation.lastUpdatedBy === negotiation.lastInitiatorId
        if (isWithdrawnByInitiator) {
          return ownOrder
            ? Locale.translate(Translation.SC_TICKET_WITHDRAWN_ACTOR_NARRATIVE)
            : Locale.translate(Translation.SC_TICKET_WITHDRAWN_RECEIVER_NARRATIVE)
        } else {
          return ownOrder
            ? Locale.translate(Translation.SC_TICKET_WITHDRAWN_RECEIVER_NARRATIVE)
            : Locale.translate(Translation.SC_TICKET_WITHDRAWN_ACTOR_NARRATIVE)
        }
      case NegotiationStatus.QUOTED_SUBJECT:
        return Locale.translate(Translation.SC_TICKET_QUOTE_SUBJECT_NARRATIVE)
      case NegotiationStatus.CANCELLED:
        return ownOrder
          ? Locale.translate(Translation.SC_TICKET_CANCELLED_INITIATOR_NARRATIVE)
          : Locale.translate(Translation.SC_TICKET_CANCELLED_RESPONDER_NARRATIVE)

      default:
        return null
    }
  }

  private handleRevert = () => {
    const { negotiationDetail, onInitiatorRevert, onResponderRevert } = this.props

    if (negotiationDetail.ownOrder) {
      onInitiatorRevert(negotiationDetail.negotiation.negotiationId, negotiationDetail.ownOrder)
    } else {
      onResponderRevert(negotiationDetail.negotiation.negotiationId, negotiationDetail.ownOrder)
    }
  }
}

export const RFQTicketNarrativeBar = connect(null, mapDispatchToProps)(RFQTicketNarrativeBarComponent)
